import * as inss from '@/api/inss'
import * as consulta from '@/api/consultas'
import store from '@/store/'

import { qualMargem } from '@/service/pedido'

const state = {
  id: false,
  dados: [],
  semBeneficios: false,
  extratoHTML: '',
  modalExtrato: false,
  itens: [],
  modalMargemNegativa: false,
  modalMargemPositivavel: false,
  triggerGetBeneficios: false,
  modalHistoricoExtrato: false,
  loadRecalculo: false,
  existePositivar: false,
  semSaldoConsulta: false
}

const getters = {}

const mutations = {
  CLEAN (state) {
    state.id = false
    state.dados = []
  },
  SETID (state, id) {
    state.id = id
  },
  SETBENEFICIOS (state, payload) {
    state.dados = []
    state.semBeneficios = false
    state.dados = payload.beneficios.map(i => {
      return {
        numero: i.beneficio,
        extrato: {
          beneficio: {
            especie: i.especie,
            dib: i.dib,
            tipo: i.tipo
          }
        }
      }
    })
  },
  SETEXTRATO (state, { indice, result }) {
    if (result && result.beneficio && result.beneficio.base_calc && typeof (result.beneficio.base_calc) === 'number') result.beneficio.base_calc = result.beneficio.base_calc.toFixed(2)
    if (indice > -1) state.dados[indice].extrato = result
  },
  SEMBENEFICIOS (state, payload) {
    state.semBeneficios = payload
  },
  SEMSALDO (state, payload) {
    state.semSaldoConsulta = payload
  },
  SETEXTRATOHTML (state, result) {
    state.extratoHTML = result
  },
  SETMODALEXTRATO (state, payload) {
    state.modalExtrato = payload
  },
  SETITENSINSS (state, payload) {
    state.itens = payload
  },
  MODALMARGEMNEGATIVA (state) {
    state.modalMargemNegativa = !state.modalMargemNegativa
  },
  MODALMARGEMPOSITIVAVEL (state) {
    state.modalMargemPositivavel = !state.modalMargemPositivavel
  },
  HIDDEMODAL (state) {
    state.modalMargemNegativa = false
  },
  HIDDEMODALPOSITIVAVEL (state) {
    state.modalMargemPositivavel = false
  },
  ATUALIZAORCAMENTOSTORE (state, payload) {
    state.dados[payload.indice].extrato.beneficio = payload.orcamento
  },
  SETTRIGGERGETBENEFICIOS (state) {
    state.triggerGetBeneficios = !state.triggerGetBeneficios
  },
  TOGGLEHISTORICOEXTRATO (state) {
    state.modalHistoricoExtrato = !state.modalHistoricoExtrato
  },
  SETLOADRECALCULO (state, payload) {
    state.loadRecalculo = payload
  },
  SETEXISTEPOSSIBILIDADEPOSITIVAR (state, payload) {
    state.existePositivar = payload
  }
}

const actions = {
  modalExtrato ({ commit }, payload) {
    commit('SETMODALEXTRATO', payload)
    if (!payload) {
      commit('SETEXTRATOHTML', '')
    }
  },
  modalMargemNegativa: function ({ commit }) {
    commit('MODALMARGEMNEGATIVA')
  },
  modalMargemPositivavel: function ({ commit }) {
    commit('MODALMARGEMPOSITIVAVEL')
  },
  hiddeModalPositivavel: function ({ commit }) {
    commit('HIDDEMODALPOSITIVAVEL')
  },
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  async cleanBeneficios ({ commit }) {
    commit('CLEAN')
  },
  async getBeneficios ({ commit }, id) {
    commit('SETID', id)
    try {
      let result = await inss.getBeneficios(id)
      commit('SETBENEFICIOS', result)
    } catch (e) {
      if (e.message === 'Saldo indisponível!') commit('SEMSALDO', true)
      else commit('SEMBENEFICIOS', true)
    }
  },
  async getCalculoInicial ({ commit, state }, payload) {
    try {
      return inss.getCalculoInicial(payload)
    } catch (e) {
      throw e
    }
  },
  async getExtratoAtualizado ({ commit, state }, beneficio) {
    const indice = state.dados.findIndex(i => i.numero === beneficio.numero)
    try {
      let result = await inss.getExtratoAtualizado(state.id, beneficio.numero)
      if (result.id) commit('SETEXTRATO', { indice, result })
    } catch (e) {
      throw e
    }
  },
  async getExtratoBase ({ commit, state }, beneficio) {
    const indice = state.dados.findIndex(i => i.numero === beneficio.numero)
    try {
      let queryString = ''
      if (typeof beneficio.permiteCalcular !== 'undefined') {
        queryString = '?permiteCalcular=' + beneficio.permiteCalcular
      }
      let result = await inss.getExtratoBase(state.id, beneficio.numero, queryString)
      if (result.id) commit('SETEXTRATO', { indice, result })
      return result
    } catch (e) {
      throw e
    }
  },
  async getExtratoRecalculo ({ commit, state }, dados) {
    try {
      return inss.getExtratoRecalculo(state.id, dados.beneficio.numero, dados)
    } catch (e) {
      throw e
    }
  },
  async getExtratoRecalculoSemLoad ({ commit, state }, dados) {
    try {
      return inss.getExtratoRecalculo(state.id, dados.beneficio.numero, dados)
    } catch (e) {
      throw e
    }
  },
  async getExtratoTodosRecalculo ({ commit, state }, id) {
    try {
      commit('SETLOADRECALCULO', true)
      return inss.getExtratoTodosRecalculo(id)
    } catch (e) {
      commit('SETLOADRECALCULO', false)
      throw e
    }
  },
  async getExtratoReabre ({ commit, state }, beneficio) {
    const indice = state.dados.findIndex(i => i.numero === beneficio.numero)
    try {
      let result = await inss.getExtratoReabre(state.id, beneficio.numero)
      commit('SETEXTRATO', { indice, result })
    } catch (e) {
      throw e
    }
  },
  async getExtratoHTML ({ commit }, beneficio) {
    let result = await consulta.extrato(beneficio)
    store.dispatch('pedidoInss/modalExtrato', true)
    commit('SETEXTRATOHTML', result)
  },
  async getHiscon (context, beneficio) {
    return consulta.hiscon(beneficio.numero)
  },
  async getItens ({ commit }, pedido) {
    let result = await inss.getItens(pedido)
    commit('SETITENSINSS', result)
  },
  async lancar ({ commit }, dados) {
    let result = await inss.lancar(store.state.pedido.emAtendimento.id, dados)
    return result
  },
  async salvaContrato ({ commit }, dados) {
    let result = await inss.salvaContrato(dados)
    return result
  },
  async editContrato ({ commit }, dados) {
    return inss.editContrato(dados)
  },
  async excluirContrato ({ commit }, id) {
    let result = await inss.excluiContrato(id)
    return result
  },
  async salvarBaseCalculo ({ commit }, payload) {
    let result = await inss.salvarBaseCalculo(payload)
    return result
  },
  async salvaBeneficio ({ commit }, payload) {
    let result = await inss.salvarBeneficio(payload)
    return result
  },
  async atualizaOrcamentoStore ({ commit }, payload) {
    commit('ATUALIZAORCAMENTOSTORE', payload)
  },
  async calculaImpostoRenda ({ commit }, payload) {
    let result = await inss.calculaImpostoRenda(payload)
    return result
  },
  actionTriggerGetBeneficios ({ commit }) {
    commit('SETTRIGGERGETBENEFICIOS')
  },
  async extratoOnline ({ commit }, payload) {
    let result = await consulta.extratoOnline(payload)
    return result.instancia
  },
  async consultaIN100 ({ commit }, payload) {
    let result = await consulta.consultaIN100(payload)
    return result.instancia
  },
  toggleHistoricoExtrato ({ commit }) {
    commit('TOGGLEHISTORICOEXTRATO')
  },
  verificaMargem ({ commit, state }, payload) {
    let podePosi = false
    const i = state.dados.findIndex(item => {
      return item.numero === payload
    })
    if (i > -1) {
      let margem = qualMargem(state.dados[i].extrato.beneficio)
      if (margem < 0) {
        let contratos = state.dados[i].extrato.beneficio.contratos
        if (contratos.length) {
          contratos.forEach(contrato => {
            if (contrato.item.check) {
              if (contrato.item.modalidade === 'port_refin_novo' || contrato.item.modalidade === 'port_refin') {
                if (contrato.item.port.parcela) {
                  if (contrato.parcela > contrato.item.port.parcela) {
                    if ((margem + (contrato.parcela - contrato.item.port.parcela)) > 0) podePosi = true
                  }
                }
              } else if (contrato.item.modalidade === 'refin_novo') {
                if (contrato.item.refin.parcela) {
                  if (contrato.parcela > contrato.item.refin.parcela) {
                    if ((margem + (contrato.parcela - contrato.item.refin.parcela)) > 0) podePosi = true
                  }
                }
              } else if (contrato.item.modalidade === 'refin') {
                if (contrato.item.parcela) {
                  if (contrato.parcela > contrato.item.parcela) {
                    if ((margem + (contrato.parcela - contrato.item.parcela)) > 0) podePosi = true
                  }
                }
              }
            }
          })
        }
      }
      if (podePosi) {
        commit('MODALMARGEMPOSITIVAVEL')
        commit('SETEXISTEPOSSIBILIDADEPOSITIVAR', true)
      } else {
        commit('MODALMARGEMNEGATIVA')
        commit('SETEXISTEPOSSIBILIDADEPOSITIVAR', false)
      }
    }
  },
  setPositivar ({ commit }, payload = true) {
    commit('SETEXISTEPOSSIBILIDADEPOSITIVAR', payload)
  },
  async setExtratoBase ({ commit, state }, extrato) {
    try {
      const indice = state.dados.findIndex(i => i.numero === extrato.beneficio.beneficio)
      commit('SETEXTRATO', { indice, result: extrato })
      return true
    } catch (e) {
      console.log(e)
    }
  },
  finalizaLoadRecalculo ({ commit }) {
    commit('SETLOADRECALCULO', true)
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/inss.js